import { render, staticRenderFns } from "./liaobei.vue?vue&type=template&id=89c60950&scoped=true&"
import script from "./liaobei.vue?vue&type=script&lang=js&"
export * from "./liaobei.vue?vue&type=script&lang=js&"
import style0 from "./liaobei.vue?vue&type=style&index=0&id=89c60950&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c60950",
  null
  
)

export default component.exports